import uiActions from "../../redux/ui/action";
import { EXPLORE_COURSES_PATH } from "../../custom_utilities/dashboardBannerNavigation";
import { clearExploreCoursesScrollState } from "../DashboardCourses/utils/exploreCoursesScrollRestore";
import { clearStudyDashboardScrollState } from "../StudyDashboard/utils/studyDashboardScrollRestore";

export const DASHBOARD_HOME_PATH = "/dashboard";

export function isDashboardHomePath(pathname = "") {
  return pathname.replace(/\/$/, "") === DASHBOARD_HOME_PATH;
}

export function isExploreMotionHomePath(pathname = "") {
  return pathname.replace(/\/$/, "") === EXPLORE_COURSES_PATH;
}

export function scrollDashboardPageToTop() {
  const content = document.querySelector(".dashboard-content");
  if (content) {
    content.scrollTop = 0;
    content.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

export function navigateToExploreMotion(history, dispatch, options = {}) {
  clearExploreCoursesScrollState();
  dispatch(uiActions.startLoading());
  const versionQuery = options?.storeVersion ? `?version=${options.storeVersion}` : "";
  history.push(`${EXPLORE_COURSES_PATH}${versionQuery}`);
  scrollDashboardPageToTop();
}

export function navigateToDashboardHome(history, dispatch) {
  clearStudyDashboardScrollState();
  dispatch(uiActions.finishLoading());
  history.push(DASHBOARD_HOME_PATH);
  scrollDashboardPageToTop();
}
